import styled from 'styled-components';

const FileName = styled.span`
  font-size: ${(p) => p.theme.fontSizes.sm};
  color: ${(p) => p.theme.colors.gray200};
`;

export { FileName };
